'use client';

import type { FC } from 'react';
import type { NotificationTickerDataType } from '@weberus/shared-types';
import type { HomeLogPageNameValue } from '@/app/(pages)/sub-home/[category]/constants';
import { NotificationTicker as NotificationTickerWidget } from '@weberus/ui/components/notification-ticker';
import { clientLogStandardized, YaTrackerImpression } from '@weberus/client-tracker';
import { yaNative } from '@weberus/ui/utils/ya-native';
import { waitUntilClickTimeout } from '@weberus/utils';

/**
 * 위젯_공지
 *
 * @see {@link https://www.figma.com/design/zlHuiOHmYv1ghVDbTHUSvW/%5BGUIDE%5D-%EC%9C%84%EC%A0%AF%2F%EC%98%A4%EB%8D%94%EB%A7%81?node-id=4-14&node-type=canvas&t=OaPq9VxMsJp0eFnJ-0}
 */

export interface NotificationTickerProps {
  data?: NotificationTickerDataType;
  pageNameLog: HomeLogPageNameValue;
}

export const NotificationTicker: FC<NotificationTickerProps> = ({ pageNameLog, data }) => {
  const title = data?.items[0]?.items[0]?.title;
  const action = data?.items[0]?.items[0]?.action;
  const logMeta = data?.items[0]?.items[0]?.logMeta;
  const widgetLogMeta = data?.logMeta;

  if (!title) {
    return null;
  }

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    await waitUntilClickTimeout(clientLogStandardized('click', pageNameLog, { ...widgetLogMeta, ...logMeta }));

    if (!action) return;

    if (yaNative.isEnabled) {
      yaNative.deepLink({ link: action.app });
    } else {
      location.href = action.web;
    }
  };

  return (
    <YaTrackerImpression
      className="w-full pc:w-pc-size"
      onImpressed={() => clientLogStandardized('impression', pageNameLog, { ...widgetLogMeta, ...logMeta })}>
      <NotificationTickerWidget title={title} onClick={handleClick} />
    </YaTrackerImpression>
  );
};
